import { render, staticRenderFns } from "./CompanionAnimalExistingAgreement.vue?vue&type=template&id=3a97e4b8"
import script from "./CompanionAnimalExistingAgreement.vue?vue&type=script&lang=ts"
export * from "./CompanionAnimalExistingAgreement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports